import { Skeleton } from '@heroui/react';

export const CartSum = ({
  sum = '5',
  count = '1 000',
  isLoading = false,
}: {
  count?: number | string;
  sum?: number | string;
  isLoading?: boolean;
}) => {
  return (
    <div className="bg-[#F5F5F5] p-4 rounded-2xl flex flex-col gap-y-4">
      <div className="flex flex-row items-center justify-between">
        <p className="text-[#60656C] text-sm">Кол-во товаров:</p>
        <Skeleton isLoaded={!isLoading}>
          <p className="text-[#222222] font-semibold text-lg">{count} шт</p>
        </Skeleton>
      </div>

      <div className="flex flex-row items-center justify-between">
        <p className="text-[#60656C] text-sm">Общая сумма:</p>
        <Skeleton isLoaded={!isLoading}>
          <p className="text-[#222222] font-semibold text-lg">{sum} ₸</p>
        </Skeleton>
      </div>
    </div>
  );
};
